import Script from 'next/script';
import {useSelector} from 'react-redux';

import type {AppState} from '@jobseeker/common-core/types';
import {Box} from '@mui/material';

export const StoryInjection = () => {
  const {
    userId,
    authInfo: {token},
  } = useSelector((state: AppState) => state.auth);

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  return (
    <>
      <Box
        id="company-story-feed"
        display={{xxs: 'none', md: token ? 'block' : 'none'}}
        sx={
          isAppIimjobs
            ? {
                borderRadius: '16px',
                boxShadow: '0px 6.48px 6px 2px rgba(41, 41, 41, 0.02)',
                mb: 2,
                padding: '4px 16px 16px 16px',
                background: 'white',
                cursor: 'pointer',
                minHeight: '136px',
              }
            : {mt: {md: -2, xxs: 0}}
        }
      />
      {token && (
        <Script
          id={`${process.env.NEXT_PUBLIC_APP_NAME}-story-feed`}
          dangerouslySetInnerHTML={{
            __html: `
              const gaLabel = 'Origin=jobfeed, UserId=${userId}, Device=Web';

              // TEMPORARY EVENT TO HANDLE GAQ UNDEFINED ERROR 
              // TODO: Remove after implementing Google Analytics

              const _gaq = { push: ([...args]) => console.log('GAQ', args) };
              const config = {
                domain: '${process.env.NEXT_PUBLIC_APP_DOMAIN}',
                authToken: '${token}',
                gaEventCbs: {
                  view: (storyData) => {
                    _gaq.push([
                      '_trackEvent',
                      'WebStoriesIimjobs',
                      'jsViewsWebStories',
                      gaLabel,
                    ]);
                    window?.tracking?.doTracking({
                      uba: { 
                        eventName: 'storiesView', 
                        keyNames: {
                          page: 'Jobfeed',
                          actionSrc: 'normal',
                          actionType: 'view',
                          sessionUsername: sessionStorage.getItem('userId') || '',
                          ref: new URL(window.location.href).searchParams.get('ref') || '',
                          storyId: storyData?.id || "",
                          companyID: storyData.header?.companyId || "",
                          companyName: storyData.header?.heading || "",
                        }
                      },
                    });
                  },
                  swipeup: (storyData) => {
                    _gaq.push([
                      '_trackEvent',
                      'WebStoriesIimjobs',
                      'jsClickCtaWebStories',
                      gaLabel,
                    ]);
                    window?.tracking?.doTracking({
                      uba: { 
                        eventName: 'storiesClick', 
                        keyNames: {
                          page: 'Jobfeed',
                          actionSrc: 'normal',
                          actionType: 'click',
                          sessionUsername: sessionStorage.getItem('userId') || '',
                          ref: new URL(window.location.href).searchParams.get('ref') || '',
                          companyID: storyData?.companyId || "",
                          companyName: storyData?.companyName || "",
                          storyID: storyData?.storyId || "",
                          clickType: "SwipeUp",
                        }
                      },
                    });
                  },
                  title: () => {
                    _gaq.push([
                      '_trackEvent',
                      'WebStoriesIimjobs',
                      'jsClickCompanyNameWebStories',
                      gaLabel,
                    ]);
                  },
                  clap: (storyData) => {
                    _gaq.push([
                      '_trackEvent',
                      'WebStoriesIimjobs',
                      'jsClickClapWebStories',
                      gaLabel,
                    ]);
                    window?.tracking?.doTracking({
                      uba: { 
                        eventName: 'storiesClick', 
                        keyNames: {
                          page: 'Jobfeed',
                          actionSrc: 'normal',
                          actionType: 'click',
                          sessionUsername: sessionStorage.getItem('userId') || '',
                          ref: new URL(window.location.href).searchParams.get('ref') || '',
                          clickType: "Clap",
                          companyID: storyData?.companyId || "",
                          companyName: storyData?.companyName || "",
                          storyID: storyData?.storyId || "",
                        }
                      },
                    });
                  }
                }
              };
              console.log('Loaded the story feed');
              if (typeof window !== 'undefined') {
                window.storyFeedPlugin?.storyFeedPluginInit(config);
              }
              `,
          }}
        />
      )}
    </>
  );
};

export default StoryInjection;
